/**
 * Client-side "credits may have changed" signal.
 *
 * Charges settle server-side (render settle, AI chat, caption jobs, video
 * analysis), often slightly after the client sees the job finish. Features
 * call {@link notifyCreditsChanged} when such work ends; `SubscriptionProvider`
 * listens and refetches the balance so in-tab UI (e.g. the editor header
 * capsule) doesn't stay stale until the next focus/visibility change.
 */

export const CREDITS_CHANGED_EVENT = "loopcut:credits-changed";

/**
 * Refetch schedule after a credits-changed signal: once shortly, and again
 * after the 5s `/api/credits` server cache has expired, since settlement can
 * land a few seconds after completion (renders settle after the email step).
 */
export const CREDITS_CHANGED_REFETCH_DELAYS_MS = [1_500, 8_000] as const;

export function notifyCreditsChanged(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(CREDITS_CHANGED_EVENT));
}
